<div class="list-single-main-item fl-wrap block_box" id="sec5">
    <div class="list-single-main-item-title">
        <h3>Item Reviews - <span> {{feedTotal}} </span></h3>
    </div>
    <!--reviews-score-wrap-->
    <div class="reviews-score-wrap fl-wrap" *ngIf="feedAvg">
        <div class="review-score-total">
            <span class="review-score-total-item"> {{feedAvg | number:'1.1-1'}} </span>
        </div>
        <div class="review-score-detail pt-2">
            <app-star-rating [rating]='feedAvg' [readonly]="true"></app-star-rating>
        </div>
    </div>
    <!-- reviews-score-wrap end -->
    <div class="list-single-main-item_content fl-wrap">
        <div class="alert alert-warning p-2 mb-0" *ngIf="!feedAvg"> No customer review...</div>
        <div class="reviews-comments-wrap" *ngIf="feedAvg">
            <!-- reviews-comments-item -->
            <div class="reviews-comments-item" *ngFor="let item of feedList?.data">
                <div class="review-comments-avatar">
                    <img src="../../assets/images/avatar/avatar-bg.png" alt="{{item.name}}">
                </div>
                <div class="reviews-comments-item-text fl-wrap">
                    <div class="reviews-comments-header fl-wrap">
                        <h4><a href="javascript:void(0)" title="{{item.name}}">{{item.name}}</a></h4>
                        <div class="review-score-user">
                            <span class="review-score-user_item">{{item.feedRating}}</span>
                            <div class="listing-rating card-popup-rainingvis"><app-star-rating
                                    [rating]='item.feedRating' [readonly]="true"></app-star-rating></div>
                        </div>
                    </div>
                    <p class="mb-0">{{item.feedMessage}}</p>
                    <div class="review-images ">
                        <a [href]="[serverImgUrl] + '/feedsImages/' + [item.feedPhoto] || '../../assets/images/all/1.jpg'"
                            target="_blank" class="image-popup">
                            <img [src]="[serverImgUrl] + '/feedsImages/' + [item.feedPhoto] || '../../assets/images/all/1.jpg'"
                                alt="{{item.feedMessage}}">
                        </a>
                    </div>
                    <div class="clearfix"></div>
                    <div class="reviews-comments-item-footer fl-wrap">
                        <div class="reviews-comments-item-date"><span><i
                                    class="far fa-calendar-check"></i>{{item.feedDate}}</span></div>
                        <a href="javascript:void(0)" class="rate-review"><i class="fal fa-thumbs-up"></i> Helpful Review
                            <span>{{item.feedRating}}</span> </a>
                    </div>
                </div>
            </div>
            <!--reviews-comments-item end-->
        </div>
    </div>
</div>
<!-- list-single-main-item end -->
<!-- list-single-main-item -->
<div class="list-single-main-item fl-wrap block_box" id="sec6">
    <div class="list-single-main-item-title fl-wrap">
        <h3>Add Review</h3>
    </div>
    <!-- Add Review Box -->
    <div id="add-review" class="add-review-box">
        <!-- Review Comment -->
        <form id="add-comment" class="add-comment custom-form" name="rangeCalc" [formGroup]="addFeedForm"
            (ngSubmit)="submitFeedInfo()">
            <fieldset>
                <!-- <input type="hidden" formControlName="userInfoId">
                <input type="hidden" formControlName="productInfoId">
                <input type="hidden" formControlName="businessId">
                <input type="hidden" formControlName="businessPhoto"> -->
                <div class="review-score-form fl-wrap">
                    <div class="col-sm-12">
                        <app-star-rating [rating]='rating' (newRatingEvent)="setRating($event)" [readonly]="false"></app-star-rating>
                        <span class="d-none">{{rating}}</span>
                        <div class="clearfix"></div>
                    </div>
                    <div class="review-total hide">
                        {{feedRating}}
                        <strong>Your Score</strong>
                    </div>
                </div>
                <div class="list-single-main-item_content fl-wrap">
                    <div class="row">
                        <div class="col-md-6">
                            <label><i class="fal fa-user"></i></label>
                            <input type="text" placeholder="Your Name *" formControlName="name" />
                        </div>
                        <div class="col-md-6">
                            <label><i class="fal fa-envelope"></i> </label>
                            <input type="text" placeholder="Email Address*" formControlName="email" />
                        </div>
                    </div>
                    <textarea cols="40" rows="2" placeholder="Your Review:" formControlName="feedMessage"></textarea>
                    <div class="clearfix"></div>
                    <div class="listsearch-input-item fl-wrap">
                        <div class="fuzone">
                            <div class="fu-text" style="margin: 10px 0;">
                                <span><i class="fal fa-images"></i> Click here or drop files to upload</span>
                                <div class="photoUpload-files fl-wrap"></div>
                            </div>
                            <input type="file" accept="image/*" class="upload" (change)="onSelectFeedPhoto($event)">
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <button class="btn btn-primary float-btn">Submit Review <i class="fal fa-paper-plane"></i></button>
                </div>
            </fieldset>
        </form>
    </div>
    <!-- Add Review Box / End -->
</div>